export default {
  cartDrawer: {
    upsell: {
      dropdownChanged: 'upsell:variantChange'
    }
  }
}